import { Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TabSection = ({ activeTab, setActiveTab }) => {
  const theme = useTheme();

  const tabs = [
    { id: 'profile', label: 'Profile' },
    { id: 'posts', label: 'Posts' },
    { id: 'replies', label: 'Replies' },
    // { id: 'aiReplies', label: 'AI Replies' },
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Box display='flex' flexDirection='row' justifyContent='start'>
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            sx={{
              mx: 2,
              cursor: 'pointer',
              borderBottom:
                activeTab === tab.id
                  ? `4px solid ${theme.palette.text.primary}`
                  : 'none',
              pb: 0.5,
            }}
          >
            <Typography
              variant='body2'
              // variant={activeTab === tab.id ? 'body1' : 'body2'}
              color={activeTab === tab.id ? 'text.primary' : 'text.secondary'}
              fontWeight={activeTab === tab.id ? 600 : 400}
            >
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
      <Divider />
    </Box>
  );
};

export default TabSection;
